module.exports = __webpack_public_path__ + "img/1547025624.0132bc27.jpg";